import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import { withRouter  } from 'react-router-dom';

class ReportOtherExpenditureTable extends Component {
    renderThead() {
        return (
            <thead className="kt-datatable__head" style={{ backgroundColor: '#f7f7f7' }}>
                <tr className="kt-datatable__row">                    
                    <th className="kt-datatable__cell" style={{ width: '40%', minWidth: '150px', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Операция</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Сумма</span>
                    </th>                    
                </tr>
            </thead>
        );
    }

    getNormalizedArticles(deleted) {
        if (!deleted || deleted.length === 0) return [];
    
        const map = new Map();
    
        for (const item of deleted) {
            const { id, name, typeTransaction } = item;
            const existing = map.get(id);
    
            if (!existing) {
                map.set(id, { id, name, typeTransaction });
            } else {
                let newType = existing.typeTransaction;
                const currentType = typeTransaction;
    
                if (newType === 'all' || currentType === 'all') {
                    newType = 'all';
                } else if (newType !== currentType) {
                    newType = 'all';
                }

                map.set(id, {
                    id,
                    name: existing.name,
                    typeTransaction: newType,
                });
            }
        }
    
        return Array.from(map.values());
    }

    getArticles() {
        if (isEmpty(this.props.otherExpenditures)) return [];
        const entity = this.props.items;
        const ids = entity.map((item) => item.id);
        const deleted = this.props.otherExpenditures.filter((item) => item.articleId && !ids.includes(item.articleId));
        let normalizedArticles = [];
        if (!isEmpty(deleted)) normalizedArticles = this.getNormalizedArticles(deleted.map((item) => ({ id: item.articleId, name: item.name, typeTransaction: item.typeTransaction })));
        return [ ...entity, ...normalizedArticles];
    }
    
    renderBody(items) {
        return (
            <tbody className="kt-datatable__body">
                {
                    items.filter((item) => {
                        let check = true;
                        if (this.props.filters && this.props.filters.article && this.props.filters.article.value) check = check && (item.id === this.props.filters.article.value);
                        if (this.props.filters && this.props.filters.typeTransaction) check = check && (item.typeTransaction === this.props.filters.typeTransaction.value || item.typeTransaction === 'all');
                        return check;
                    })
                    .map(item => {
                        return (
                            <tr key={item.id} className="kt-datatable__row">
                            <td className="kt-datatable__cell" style={{ width: '40%', minWidth: '150px' }}>
                                <span>
                                    {item.name}
                                </span>
                            </td>                      
                            <td className="kt-datatable__cell">
                                {this.props.otherExpenditures ?
                                <span>
                                    {(this.props.otherExpenditures.reduce((acc, el) => {
                                        let check = true;
                                        check = check && (el.articleId ? el.articleId === item.id : el.name === item.name);
                                        if (this.props.filters && this.props.filters.typeTransaction) check = check && (el.typeTransaction === this.props.filters.typeTransaction.value);
                                        if(check) return acc + parseFloat(el.sum);
                                        return acc;
                                    }, 0)).toFixed(2)}
                                </span>
                                :
                                <span>0.00</span>
                                }
                            </td>                            
                        </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    render() {
        const items = this.getArticles();
        if (items.length === 0) return <div></div>;
        
        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {this.renderThead()}
                {this.renderBody(items)}
            </table>
        );
    }
}

export default withRouter(ReportOtherExpenditureTable);